import { render } from "./FnbExtrasRevenue.vue?vue&type=template&id=5ed4dac2&scoped=true"
import script from "./FnbExtrasRevenue.vue?vue&type=script&lang=js"
export * from "./FnbExtrasRevenue.vue?vue&type=script&lang=js"

import "./FnbExtrasRevenue.vue?vue&type=style&index=0&id=5ed4dac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed4dac2"]])

export default __exports__